module.exports = __webpack_public_path__ + "img/970204987_1200.066df167.jpg";